import { BaseModel } from "@/models/base.model"
import { ModelFactory } from "@/factories/model-factory"
import { Product } from "@/models/product.model"
import type { IInstructionFeedbackActivityTemplateProduct } from "@/interfaces/api/instruction-feedback-activity-template-product.interface.ts"

export class InstructionFeedbackActivityTemplateProduct
  extends BaseModel
  implements IInstructionFeedbackActivityTemplateProduct
{
  public static className = "InstructionFeedbackActivityTemplateProduct"
  public static verboseName = "terugkoppelingsactiviteittemplate product"

  template: string
  product?: Product | null
  quantity?: string
  customProductName?: string | null

  constructor(templateProduct: IInstructionFeedbackActivityTemplateProduct) {
    super(templateProduct)

    this.template = templateProduct.template
    this.product = ModelFactory.childModel(Product, templateProduct.product)
    this.quantity = templateProduct.quantity
    this.customProductName = templateProduct.customProductName
  }
}
